import { render } from "./CreateItemModal.vue?vue&type=template&id=6f89aadb&scoped=true"
import script from "./CreateItemModal.vue?vue&type=script&lang=js"
export * from "./CreateItemModal.vue?vue&type=script&lang=js"

import "./CreateItemModal.vue?vue&type=style&index=0&id=6f89aadb&scoped=true&lang=css"
import "./CreateItemModal.vue?vue&type=style&index=1&id=6f89aadb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f89aadb"]])

export default __exports__